export const times = [...Array(48).keys()].map((i) => {
  const hour = Math.floor(i / 2).toString().padStart(2, '0')
  const minute = i % 2 === 0 ? '00' : '30'
  return `${hour}:${minute}`
})